import React from 'react'
import { Linking, View } from 'react-native'
import { BtText } from '@linqpal/components/src/ui'
import { PhoneIconBlue } from '../../../../assets/icons'
import { currencyMask } from '../../../../utils/helpers/masking'
import { useTranslation } from 'react-i18next'
import { parsePhoneNumber } from 'libphonenumber-js'

export default function Header({
  company,
  totalAmount,
  style,
  companyFontSize = 18,
}) {
  const { t } = useTranslation('global')

  return (
    <View style={style}>
      <View style={{ flex: 1 }}>
        <BtText
          size={companyFontSize}
          weight={'600'}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {company?.name}
        </BtText>
        {company.phone ? (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: 7,
            }}
          >
            <PhoneIconBlue />
            <BtText
              style={{ color: '#00A0F3', marginLeft: 5 }}
              weight={'500'}
              onPress={() => {
                Linking.openURL(`tel:${company.phone}`)
              }}
            >
              {parsePhoneNumber(company.phone, 'US')
                .formatInternational()
                .slice(3)}
            </BtText>
          </View>
        ) : null}
      </View>
      <View style={{ alignItems: 'flex-end' }}>
        <BtText weight="600" size={18}>
          {currencyMask(totalAmount)}
        </BtText>
        <BtText style={{ color: '#99ADBA', marginTop: 7 }} weight={'500'}>
          {t('TabInvoice.amount_due')}
        </BtText>
      </View>
    </View>
  )
}
